import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Admin, AdminRole } from '../models/admin.model';
import { PaginatedResult, Result } from './common.interface';

export interface SaveAdminBody {
  name?: string | null;
  email?: string;
  password?: string;
  role?: AdminRole;
  permissions?: string[];
  categoryIds?: number[];
}

@Injectable({ providedIn: 'root' })
export class AdminGatewayService {
  private readonly BASE_URL = `${environment.baseUrl}/admin/admin`;

  constructor(private readonly http: HttpClient) {}

  admins(
    keyword?: string | null,
    pagination?: { page: number }
  ): Observable<PaginatedResult<Admin[]>> {
    let params = new HttpParams({ fromObject: { ...pagination, limit: 10 } });

    if (keyword) {
      params = params.append('keyword', keyword);
    }

    return this.http.get<PaginatedResult<Admin[]>>(this.BASE_URL, { params });
  }

  addAdmin(body: SaveAdminBody): Observable<Result<Admin>> {
    return this.http.post<Result<Admin>>(this.BASE_URL, body);
  }

  editAdmin(id: number, body: SaveAdminBody): Observable<Result<Admin>> {
    return this.http.patch<Result<Admin>>(`${this.BASE_URL}/${id}`, body);
  }

  deleteAdmin(id: number): Observable<Result<void>> {
    return this.http.delete<Result<void>>(`${this.BASE_URL}/${id}`);
  }

  me(): Observable<Result<Admin>> {
    return this.http.get<Result<Admin>>(`${environment.baseUrl}/admin/auth/me`);
  }
}
